import { render, staticRenderFns } from "./SummaryLikesAndRepostsBody.vue?vue&type=template&id=05b16c62&"
import script from "./SummaryLikesAndRepostsBody.vue?vue&type=script&lang=js&"
export * from "./SummaryLikesAndRepostsBody.vue?vue&type=script&lang=js&"
import style0 from "./SummaryLikesAndRepostsBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports